import { React, StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { GoogleOAuthProvider } from '@react-oauth/google';
import reducers from './state/reducers';
import App from './app';
import './style.scss';

const store = configureStore({
  reducer: reducers,
  middleware: [thunk],
});

const root = ReactDOM.createRoot(document.getElementById('main'));

root.render(
  <StrictMode>
    <GoogleOAuthProvider clientId="981184541418-fiubq953gb9eo775ptrj5vl7jcher6qa.apps.googleusercontent.com">
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </StrictMode>,
);
